import './PlansExplorerPage.css';

import React, { useEffect, useState } from 'react';
import Banner from '../../b2b-common/Banner';
import { useLoginContext } from '../../../App';
import { deletePlan } from '../../../services/b2b-plans-apiService';
import B2BElementsExplorer from '../../b2b-common/B2BElementsExplorer';
import PlanCard from '../components/PlanCard';
import CustomButton from '../../b2b-common/CustomButton';
import { AddCircleOutline } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useContentContext } from '../../layout/Layout';
import { showNotification } from '../../b2b-common/Notification';
import usePlansData from '../hooks/usePlansData';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const PlansExplorerPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useB2BTranslation('b2b-plans');

    const { setNotification } = useContentContext();
    const { loginData } = useLoginContext();

    const [currentPage, setCurrentPage] = useState(1);
    const [selectedPlanId, setSelectedPlanId] = useState(null);
    const elementsPerPage = 8;

    const { organizationPlansData, setOrganizationPlansData, isSearching, pagesCount } = usePlansData(elementsPerPage, currentPage);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const selectedPlanId = Number(queryParams.get('selectedPlanId'));
        if (selectedPlanId) {
            // console.log('selectedPlanId:', selectedPlanId);
            setSelectedPlanId(selectedPlanId);
        }
    }, [location]);

    const handleDeletePlan = async (plan) => {
        // console.log('handleDeletePlan: ', plan);
        try {
            await deletePlan(loginData.accessToken, plan.planUUID);
            // console.log('deletePlan response:', response);
            if (Array.isArray(organizationPlansData.content)) {
                const newPlansData = organizationPlansData.content.reduce((acc, p) => {
                    // console.log('p:', p);
                    // console.log('p.plan.planUUID:', p.planUUID);
                    // console.log('plan.planUUID:', plan.planUUID);
                    if (p.plan.planUUID !== plan.planUUID) {
                        acc.push(p);
                    }
                    return acc;
                }, []);
                // console.log('newPlansData after deletion:', newPlansData);
                setOrganizationPlansData({
                    ...organizationPlansData,
                    content: newPlansData
                });
                showNotification(setNotification, t('Plan deleted successfully'), 'success', 3000);
                // console.log('organizationPlansData state updated:', organizationPlansData);
            } else {
                console.error('organizationPlansData.data is not an array:', organizationPlansData.content);
                showNotification(setNotification, 'Error deleting plan: organizationPlansData.data is not an array', 'error', 5000);
            }
        } catch (error) {
            console.error('Error deleting plan:', error);
            showNotification(setNotification, t('Error deleting plan: ') + error.message, 'error', 3000);
        }
    }

    const handleEditPlan = (plan) => {
        //console.log('handleEditPlan: ', plan);
        navigate(`/plans/plans-explorer/edit`, { state: { plan } });
    }

    const handleShowPlanDetails = (plan) => {
        //console.log('handleShowPlanDetails: ', plan);
        navigate(`/plans/plans-explorer/${plan.planUUID}`);
    }

    return (
        <div className='plans-explorer-page-container'>
            <Banner message={t('Plans')} underline={false} headingLevel='h1' />
            <div className='plans-explorer-actions'>
                <CustomButton label={t('New Plan')} className='plans-page-new-plan-action-button white_02'
                    icon={<AddCircleOutline />}
                    rolesAllowed={['ADMIN', 'EDITOR']} confirm={false}
                    onClick={() => { navigate('/plans/plans-explorer/new') }}
                />
            </div>
            {/* <Banner message={t('Current plans defined by the organization')} headingLevel='h3' underline={false} /> */}
            {organizationPlansData && organizationPlansData.content && (
                <B2BElementsExplorer
                    isSearching={isSearching}
                    elementsData={organizationPlansData}
                    pagesCount={pagesCount}
                    currentPage={currentPage}
                    handlePageChange={(event, value) => setCurrentPage(value)}
                    className={'plans-explorer'}
                    ElementComponent={PlanCard}
                    elementComponentPropName='plan'
                    elementComponentHandlers={{
                        onAccess: handleShowPlanDetails,
                        onEdit: handleEditPlan,
                        onDelete: handleDeletePlan,
                    }}
                    elementIDPropName='plan.planId'
                    goToID={selectedPlanId}
                />
            )}
        </div>
    );
};

export default PlansExplorerPage;